/* ═══════════════════════════════════════════════════════════════════════
   ISOFIN — Lösungsseiten → Kalkulator-Ergebnis-Flow (v337)
   v448: Messbasis Baustein 0 (loesung_section_view / loesung_exit /
         loesung_flow_invalid) — beantwortet, ob die CTA-Nicht-Klicker den
         Button nicht SEHEN oder sehen und nicht klicken.
   v449: Eingabe-Overlay statt Scroll-Sprung-Panel (Björn 13.07. abends —
         "man versteht nicht ... dass der sich aufklappt", Zielgruppe 45+,
         grobmotorisch). Jeder Berechnen-CTA öffnet dasselbe modale Fenster
         an Ort und Stelle. Spezifikation:
         AENDERUNGEN/2026-07-13_30_plan-loesungsseite-cta/OVERLAY-SPEZIFIKATION.md
   ───────────────────────────────────────────────────────────────────────
   Der CTA auf den Lösungsseiten klappt ein kurzes Geometrie-Panel auf
   (aufsteigend: Wandlänge/Ecken/Wandstärke · seitlich: +Höhe). Mauerwerk
   wird aus der Feuchte-Analyse vorbefüllt (fa_state_v2.answers.q8).

   Bei "Sanierung kalkulieren":
     1. ISO-WIZ-Module on-demand als BIBLIOTHEK laden (storage → config →
        calculations) — kein 26-isowiz-Code wird verändert.
     2. IsoWiz.Calculations.calculateFinalAnalysis(state) rechnet mit der
        ORIGINAL-Formel und speichert selbst (analysis + isofinAnalysis +
        Sticky-Keys). Zusätzlich schreiben wir den Wizard-State.
     3. Sanierungspaket-Menge ABSOLUT auf calculatedBottles setzen
        (/cart/update.js) — der Kalkulator-Loader resumed nur bei
        Cart-Menge === calculatedBottles.
     4. sessionStorage.__ISOWIZ_START_INTENT__ = {targetStep:'step-4'}
        → Sprung direkt auf die Ergebnisseite.
   Fallback bei jedem Fehler: normale Navigation zum Kalkulator-Start.

   Init pro Seite (Template):
     IsoLoesungFlow.init({ mode:'bottom'|'side', typ:'kapillar'|'seitlich',
       assets:{ storage:URL, config:URL, calculations:URL } })
   ═══════════════════════════════════════════════════════════════════════ */
(function (w, d) {
  "use strict";
  if (w.IsoLoesungFlow) return;

  var VERSION = "483.0.0";
  var VARIANT_ID = 55049427616117;
  var KALK_URL = "/pages/kalkulator";

  /* FA-Tool (fa_state_v2.answers.q8) → Wizard-Mauerwerkswerte (step-2 TYPE_LABELS) */
  var Q8_MAP = {
    brick: "ziegelstein",
    natural_stone: "naturstein",
    hollow_block: "hohlblockziegel",
    concrete: "beton",
    unknown_material: ""
  };
  var MASONRY_OPTIONS = [
    { v: "ziegelstein",    l: "Ziegelmauerwerk" },
    { v: "kalksandstein",  l: "Kalksandstein" },
    { v: "naturstein",     l: "Naturstein / Bruchstein" },
    { v: "hohlblockziegel",l: "Hohlblock / Porenbeton" },
    { v: "beton",          l: "Beton" }
  ];
  var MASONRY_LABELS = {};
  for (var mi = 0; mi < MASONRY_OPTIONS.length; mi++) MASONRY_LABELS[MASONRY_OPTIONS[mi].v] = MASONRY_OPTIONS[mi].l;

  function track(ev, data) {
    /* A6: ohne step landet das Event auf /goal und faelscht den Kauf-Zaehler "converted". */
    try { if (w.logr3Track) w.logr3Track(ev, Object.assign({ step: true }, data || {})); } catch (e) {}
  }
  function num(v) {
    var x = parseFloat(String(v == null ? "" : v).replace(",", ".").trim());
    return isFinite(x) ? x : NaN;
  }
  function readFaMasonry() {
    try {
      var raw = w.localStorage.getItem("fa_state_v2");
      if (!raw) return "";
      var st = JSON.parse(raw);
      var q8 = st && st.answers && st.answers.q8;
      return (q8 && Q8_MAP.hasOwnProperty(q8)) ? Q8_MAP[q8] : "";
    } catch (e) { return ""; }
  }

  function injectCSS() {
    if (d.getElementById("ilf-css")) return;
    /* WICHTIG: Das Panel lebt INNERHALB von .iso-fl (all:initial + "*"-Reset der
       Lösungsseiten). Deshalb: doppelte Klassen-Spezifität + !important auf allen
       visuellen Eigenschaften — gleiche bewährte Technik wie der Hendrik-Block. */
    var css = [
      ".ilf-panel.ilf-panel{display:none !important;text-align:left !important;max-width:460px !important;margin:20px auto 0 !important;background:#fff !important;border:1.5px solid #e5e7eb !important;border-radius:16px !important;padding:20px 18px 16px !important;box-shadow:0 8px 28px rgba(0,0,0,.07) !important;font-family:'Rubik',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif !important;box-sizing:border-box !important}",
      ".ilf-panel.ilf-open{display:block !important}",
      ".ilf-panel .ilf-title{display:block !important;font-size:18px !important;font-weight:700 !important;color:#0f172a !important;margin:0 0 4px !important;line-height:1.3 !important}",
      ".ilf-panel .ilf-sub{display:block !important;font-size:14px !important;color:#6b7280 !important;margin:0 0 16px !important;line-height:1.5 !important}",
      ".ilf-panel .ilf-field{display:block !important;margin:0 0 14px !important}",
      ".ilf-panel .ilf-label{display:block !important;font-size:15px !important;font-weight:600 !important;color:#374151 !important;margin:0 0 6px !important;line-height:1.35 !important}",
      ".ilf-panel .ilf-label small{font-weight:400 !important;color:#6b7280 !important;font-size:13.5px !important}",
      ".ilf-panel .ilf-input,.ilf-panel .ilf-select{display:block !important;width:100% !important;box-sizing:border-box !important;font-family:inherit !important;font-size:17px !important;color:#111 !important;background:#fff !important;border:1.5px solid #d1d5db !important;border-radius:10px !important;padding:12px 14px !important;min-height:50px !important;margin:0 !important;-webkit-appearance:none !important;appearance:none !important}",
      ".ilf-panel .ilf-select{background-image:url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='9' viewBox='0 0 14 9'><path d='M1 1l6 6 6-6' stroke='%23555' stroke-width='2' fill='none' stroke-linecap='round'/></svg>\") !important;background-repeat:no-repeat !important;background-position:right 14px center !important;padding-right:38px !important}",
      ".ilf-panel .ilf-input:focus,.ilf-panel .ilf-select:focus{outline:none !important;border-color:#64748b !important;box-shadow:0 0 0 3px rgba(100,116,139,.14) !important}",
      ".ilf-panel .ilf-input::placeholder{color:#9ca3af !important;opacity:1 !important}",
      ".ilf-panel .ilf-hint{display:block !important;font-size:13.5px !important;color:#15803d !important;margin:6px 0 0 !important;line-height:1.4 !important}",
      ".ilf-panel .ilf-err{display:none !important;font-size:13.5px !important;color:#B8001A !important;margin:5px 0 0 !important;font-weight:600 !important;line-height:1.4 !important}",
      ".ilf-panel .ilf-field.ilf-valid .ilf-input,.ilf-panel .ilf-field.ilf-valid .ilf-select{border-color:#16a34a !important;background-color:#f0fdf4 !important}",
      ".ilf-panel .ilf-field.ilf-valid .ilf-input:focus,.ilf-panel .ilf-field.ilf-valid .ilf-select:focus{border-color:#15803d !important;box-shadow:0 0 0 3px rgba(22,163,74,.16) !important}",
      ".ilf-panel .ilf-field.ilf-valid .ilf-label::after{content:'✓ Bestätigt' !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;width:auto !important;min-height:22px !important;padding:2px 8px !important;margin-left:8px !important;border-radius:999px !important;background:#dcfce7 !important;color:#166534 !important;font-size:12px !important;font-weight:800 !important;line-height:1.2 !important;white-space:nowrap !important;vertical-align:middle !important}",
      ".ilf-panel .ilf-field.ilf-invalid .ilf-err{display:block !important}",
      ".ilf-panel .ilf-field.ilf-invalid .ilf-input,.ilf-panel .ilf-field.ilf-invalid .ilf-select{border-color:#D6001C !important;background:#fff8f8 !important}",
      ".ilf-panel .ilf-stepper{display:block !important}",
      ".ilf-panel .ilf-stepper-btn{display:none !important}",
      "@media (max-width:640px){.ilf-panel .ilf-stepper{display:flex !important;align-items:stretch !important;width:100% !important;min-height:54px !important;background:#fff !important;border:2px solid #d1d5db !important;border-radius:14px !important;overflow:hidden !important;transition:border-color .15s,box-shadow .15s !important}.ilf-panel .ilf-stepper:focus-within{border-color:#64748b !important;box-shadow:0 0 0 3px rgba(100,116,139,.14) !important}.ilf-panel .ilf-stepper-btn{display:flex !important;align-items:center !important;justify-content:center !important;flex:0 0 56px !important;min-width:56px !important;min-height:54px !important;padding:0 !important;margin:0 !important;border:0 !important;border-radius:0 !important;background:#fff !important;color:#D6001C !important;font-family:inherit !important;font-size:27px !important;font-weight:700 !important;line-height:1 !important;cursor:pointer !important;touch-action:manipulation !important;-webkit-tap-highlight-color:transparent !important}.ilf-panel .ilf-stepper-btn:first-child{border-right:1px solid #d1d5db !important}.ilf-panel .ilf-stepper-btn:last-child{border-left:1px solid #d1d5db !important}.ilf-panel .ilf-stepper-btn:active{background:rgba(214,0,28,.08) !important}.ilf-panel .ilf-stepper .ilf-input{flex:1 1 auto !important;min-width:0 !important;height:54px !important;min-height:54px !important;padding:12px 8px !important;border:0 !important;border-radius:0 !important;box-shadow:none !important;background:transparent !important;text-align:center !important;font-size:20px !important;font-weight:700 !important}.ilf-panel .ilf-stepper .ilf-input:focus{border:0 !important;box-shadow:none !important;background:transparent !important}.ilf-panel .ilf-field.ilf-valid .ilf-stepper{border-color:#16a34a !important;background:#f0fdf4 !important}.ilf-panel .ilf-field.ilf-valid .ilf-stepper:focus-within{border-color:#15803d !important;box-shadow:0 0 0 3px rgba(22,163,74,.16) !important}.ilf-panel .ilf-field.ilf-invalid .ilf-stepper{border-color:#D6001C !important;background:#fff8f8 !important}.ilf-panel .ilf-field.ilf-invalid .ilf-stepper:focus-within{box-shadow:0 0 0 3px rgba(214,0,28,.14) !important}}",
      ".ilf-footer .ilf-go{display:flex !important;align-items:center !important;justify-content:center !important;gap:8px !important;width:100% !important;box-sizing:border-box !important;margin:6px 0 0 !important;padding:16px 20px !important;min-height:54px !important;border:none !important;border-radius:12px !important;cursor:pointer !important;font-family:inherit !important;font-size:17px !important;font-weight:700 !important;background:#D6001C !important;color:#fff !important;box-shadow:0 4px 14px rgba(214,0,28,.3) !important;transition:background .15s ease !important;text-align:center !important}",
      ".ilf-footer .ilf-go:hover{background:#B8001A !important}",
      ".ilf-footer .ilf-go[disabled]{opacity:.7 !important;cursor:wait !important}",
      ".ilf-footer .ilf-foot{display:block !important;font-size:13px !important;color:#6b7280 !important;text-align:center !important;margin:10px 0 0 !important;line-height:1.45 !important}",
      ".ilf-panel .ilf-label-row{display:flex !important;align-items:center !important;justify-content:space-between !important;gap:8px !important;margin:0 0 6px !important}",
      ".ilf-panel .ilf-label-row .ilf-label{margin:0 !important;flex:1 1 auto !important}",
      ".ilf-panel .ilf-info-btn{flex:0 0 auto !important;width:28px !important;height:28px !important;border-radius:50% !important;border:1.5px solid #d1d5db !important;background:#fff !important;color:#6b7280 !important;font-family:Georgia,'Times New Roman',serif !important;font-style:italic !important;font-weight:700 !important;font-size:15px !important;line-height:1 !important;cursor:pointer !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;padding:0 !important;-webkit-tap-highlight-color:transparent !important}",
      ".ilf-panel .ilf-info-btn:hover,.ilf-panel .ilf-info-btn.ilf-on{border-color:#D6001C !important;color:#D6001C !important;background:#fff8f8 !important}",
      ".ilf-panel .ilf-info-box{display:none !important;margin:8px 0 2px !important;background:#faf9f8 !important;border:1px solid #eeeceb !important;border-radius:10px !important;padding:12px 14px !important;font-size:13.5px !important;line-height:1.55 !important;color:#3a3a3a !important;text-align:left !important}",
      ".ilf-panel .ilf-info-box.ilf-open{display:block !important}",
      ".ilf-panel .ilf-info-box h4{font-size:14px !important;font-weight:700 !important;color:#1a1a1a !important;margin:12px 0 5px !important;line-height:1.35 !important}",
      ".ilf-panel .ilf-info-box h4:first-child{margin-top:0 !important}",
      ".ilf-panel .ilf-info-box p{margin:0 0 8px !important;font-size:13.5px !important;color:#3a3a3a !important;line-height:1.55 !important}",
      ".ilf-panel .ilf-info-box ul{margin:0 0 8px !important;padding:0 0 0 18px !important;list-style:disc !important}",
      ".ilf-panel .ilf-info-box li{margin:0 0 4px !important;font-size:13.5px !important;color:#3a3a3a !important;line-height:1.5 !important}",
      ".ilf-panel .ilf-info-tip{display:block !important;background:#e1f5ee !important;border-radius:8px !important;padding:9px 11px !important;margin:10px 0 0 !important;font-size:13px !important;color:#085041 !important;line-height:1.5 !important}",
      /* v399 (Björn): mobil wirkte das Panel zu eingeengt — volle Breite + kompakteres Padding */
      "@media (max-width:600px){.ilf-panel.ilf-panel{max-width:none !important;padding:16px 12px 14px !important}}",
      ".ilf-footer .ilf-almost{display:block !important;font-size:14px !important;font-weight:700 !important;color:#15803d !important;text-align:center !important;margin:0 0 8px !important;line-height:1.4 !important}",
      ".ilf-footer{display:block !important}",

      /* v449 Eingabe-Overlay — Portal in document.body (entzieht sich dem
         all:initial-Reset von .iso-fl), z-index 100200: über Header sticky
         9999, Menü-Drawer 10000, Lightbox 9999, Voice-Miniplayer 9200,
         Page-Loader 99998, Skip-Link 99999 · unter Cart-Drawer 100000.
         Sichtbarkeit über GENAU EINEN Mechanismus (Klasse, kein [hidden]):
         .ilf-ov.ilf-ov{display:none} + .ilf-ov-open{display:flex}. */
      ".ilf-ov.ilf-ov{display:none !important;position:fixed !important;inset:0 !important;z-index:100200 !important;font-family:'Rubik',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif !important;box-sizing:border-box !important}",
      ".ilf-ov.ilf-ov *{box-sizing:border-box !important}",
      /* padding-bottom = Platz für einen unten verankerten Consent-Banner (s. consentBottomOverlap).
         Mobil (align-items:flex-end) rückt das Sheet damit über den Banner; Desktop (center) bleibt
         unberührt, solange der Banner das zentrierte Sheet nicht horizontal überlappt. */
      ".ilf-ov.ilf-ov.ilf-ov-open{display:flex !important;align-items:flex-end !important;justify-content:center !important;padding-bottom:var(--ilf-ccb,0px) !important}",
      "@media (min-width:641px){.ilf-ov.ilf-ov.ilf-ov-open{align-items:center !important}}",
      /* Sobald ein Consent-Banner Platz belegt, muss auch das Desktop-/Tablet-
         Sheet im freien Bereich statt in der gesamten Viewport-Hoehe zentrieren. */
      "@media (min-width:641px){.ilf-ov.ilf-ov.ilf-ov-open.ilf-ov-has-ccb{align-items:flex-end !important}.ilf-ov.ilf-ov-has-ccb .ilf-ov-sheet{max-height:calc(var(--ilf-vvh,100dvh) - var(--ilf-ccb,0px)) !important}}",
      ".ilf-ov .ilf-ov-backdrop{position:absolute !important;inset:0 !important;background:rgba(15,23,42,.55) !important;opacity:0 !important;transition:opacity .15s ease !important}",
      ".ilf-ov.ilf-ov-open .ilf-ov-backdrop{opacity:1 !important}",
      "@media (max-width:640px){.ilf-ov .ilf-ov-backdrop{background:transparent !important}}",
      ".ilf-ov .ilf-ov-sheet{position:relative !important;display:flex !important;flex-direction:column !important;background:#fff !important;width:100% !important;height:calc(var(--ilf-vvh,100dvh) - var(--ilf-ccb,0px)) !important;max-height:calc(var(--ilf-vvh,100dvh) - var(--ilf-ccb,0px)) !important;top:var(--ilf-vvt,0px) !important;transform:translateY(24px) !important;opacity:0 !important;transition:transform .2s ease-out,opacity .2s ease-out !important}",
      ".ilf-ov.ilf-ov-open .ilf-ov-sheet{transform:translateY(0) !important;opacity:1 !important}",
      "@media (min-width:641px){.ilf-ov .ilf-ov-sheet{width:calc(100% - 40px) !important;max-width:520px !important;height:auto !important;max-height:min(90vh,860px) !important;top:auto !important;border-radius:16px !important;box-shadow:0 24px 64px rgba(0,0,0,.28) !important}}",
      ".ilf-ov .ilf-ov-head{flex:none !important;display:flex !important;align-items:flex-start !important;justify-content:space-between !important;gap:10px !important;padding:calc(14px + env(safe-area-inset-top)) 16px 14px !important;border-bottom:1px solid #e5e7eb !important}",
      "@media (min-width:641px){.ilf-ov .ilf-ov-head{padding:16px 18px 14px !important;align-items:center !important}}",
      ".ilf-ov .ilf-ov-head-text{display:flex !important;flex-direction:column !important;gap:5px !important;flex:1 1 auto !important;min-width:0 !important}",
      ".ilf-ov .ilf-ov-kicker{display:inline-block !important;align-self:flex-start !important;font-family:inherit !important;font-size:11.5px !important;font-weight:700 !important;letter-spacing:.04em !important;text-transform:uppercase !important;color:#15803d !important;background:#e7f6ee !important;border-radius:999px !important;padding:3px 10px !important;line-height:1.35 !important}",
      ".ilf-ov .ilf-ov-title{display:block !important;font-family:inherit !important;font-size:18px !important;font-weight:700 !important;color:#0f172a !important;line-height:1.3 !important}",
      ".ilf-ov .ilf-ov-x{flex:none !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;min-height:44px !important;padding:10px 14px !important;font-family:inherit !important;font-size:14px !important;font-weight:600 !important;color:#374151 !important;background:#fff !important;border:1.5px solid #d1d5db !important;border-radius:10px !important;cursor:pointer !important;-webkit-tap-highlight-color:transparent !important}",
      ".ilf-ov .ilf-ov-x:hover{background:#f3f4f6 !important}",
      ".ilf-ov .ilf-ov-scroll{flex:1 1 auto !important;overflow-y:auto !important;overscroll-behavior:contain !important;-webkit-overflow-scrolling:touch !important;padding:16px 18px 12px !important}",
      "@media (max-width:380px){.ilf-ov .ilf-ov-scroll{padding:14px 12px 12px !important}}",
      ".ilf-ov .ilf-panel.ilf-panel{border:none !important;box-shadow:none !important;max-width:none !important;margin:0 !important;border-radius:0 !important;padding:0 !important;display:block !important}",
      ".ilf-ov .ilf-title{display:none !important}",
      /* Footer ist eine ECHTE dritte Flex-Zone des Sheets (flex:none), kein
         position:sticky mehr im scrollenden Panel — verhindert Überlappung
         mit dem letzten Feld bei viel Content (4-Felder-Formular, seitlich). */
      ".ilf-ov .ilf-ov-sheet > .ilf-footer{flex:none !important;background:#fff !important;border-top:1px solid #e5e7eb !important;padding:12px 18px calc(10px + env(safe-area-inset-bottom)) !important;margin:0 !important}",
      "@media (max-width:380px){.ilf-ov .ilf-ov-sheet > .ilf-footer{padding:10px 12px calc(10px + env(safe-area-inset-bottom)) !important}}",
      "@media (min-width:641px){.ilf-ov .ilf-ov-sheet > .ilf-footer{padding:14px 18px !important}}",
      /* Bei eingeblendetem Consent-Banner bleibt der CTA absolut am unteren
         Rand des freien Sheets. So kann ein sehr niedriger Viewport den Footer
         nicht mehr aus dem Sheet heraus unter den Banner druecken. */
      ".ilf-ov.ilf-ov-has-ccb .ilf-ov-sheet > .ilf-footer{position:absolute !important;left:0 !important;right:0 !important;bottom:0 !important;z-index:3 !important}",
      ".ilf-ov.ilf-ov-has-ccb .ilf-ov-scroll{padding-bottom:calc(var(--ilf-footer-h,120px) + 12px) !important}",
      "@media (prefers-reduced-motion:reduce){.ilf-ov .ilf-ov-backdrop,.ilf-ov .ilf-ov-sheet{transition:none !important}}"
    ].join("");
    var st = d.createElement("style");
    st.id = "ilf-css";
    st.textContent = css;
    d.head.appendChild(st);
  }


  /* ⓘ-Erklärungen — Ecken + Wandstärke wörtlich aus dem ISO-WIZ (step-3),
     Länge/Höhe kurz ergänzt. Zielgruppe 45+: zum Nachlesen im Aufklapper. */
  var FIELD_INFO = {
    len: '<h4>So messen Sie die Wandlänge</h4>' +
      '<ul>' +
      '<li>Messen Sie mit Zollstock oder Maßband die Länge der Wand, an der die Feuchtigkeit sichtbar ist – am Boden entlang.</li>' +
      '<li>Sind mehrere Wandabschnitte betroffen, zählen Sie die Längen einfach zusammen.</li>' +
      '<li>Runden Sie im Zweifel auf den nächsten halben Meter auf.</li>' +
      '</ul>' +
      '<span class="ilf-info-tip"><strong>Tipp:</strong> Lieber etwas großzügiger messen – so wird der komplette feuchte Bereich sicher abgedeckt.</span>',
    hgt: '<h4>So messen Sie die Höhe</h4>' +
      '<ul>' +
      '<li>Messen Sie vom Boden bis zur oberen Kante des sichtbaren Feuchtigkeitsbereichs.</li>' +
      '<li>Geben Sie den höchsten Punkt an, wenn die Feuchtigkeit unterschiedlich hoch reicht.</li>' +
      '</ul>' +
      '<span class="ilf-info-tip"><strong>Tipp:</strong> Ein paar Zentimeter Reserve nach oben schaden nicht.</span>',
    corners: '<p>Für die Berechnung zählt nicht die optische Ecke, sondern nur zusätzlicher Wandquerschnitt im Injektionsbereich.</p>' +
      '<h4>✅ Eine Ecke wird gezählt, wenn:</h4>' +
      '<ul>' +
      '<li>sich die Wand im feuchten Bereich um 90° oder mehr fortsetzt</li>' +
      '<li>dadurch im Sperrbereich zusätzliche Wandtiefe entsteht</li>' +
      '<li>in der Ecke tatsächlich Isofin® in den erweiterten Querschnitt eingebracht werden muss</li>' +
      '</ul>' +
      '<h4>Typische Fälle:</h4>' +
      '<ul>' +
      '<li>Innen- oder Außenecke eines Raumes</li>' +
      '<li>L-förmiger Wandverlauf</li>' +
      '<li>T-Anschluss, bei dem die Querwand im feuchten Bereich liegt</li>' +
      '</ul>' +
      '<p>→ Jede dieser Stellen zählt einmal.</p>' +
      '<h4>❌ Eine Ecke wird nicht gezählt, wenn:</h4>' +
      '<ul>' +
      '<li>die Wand einfach gerade endet (freistehendes Wandende im Raum)</li>' +
      '<li>kein zusätzlicher Querschnitt im Sperrbereich entsteht</li>' +
      '<li>kein zusätzlicher Injektionsbedarf vorhanden ist</li>' +
      '</ul>' +
      '<p>Ein offenes Wandende ist keine zusätzliche Ecke, weil dort nur die normale Wandstärke vorhanden ist.</p>' +
      '<h4>Beispiele</h4>' +
      '<ul>' +
      '<li><strong>Gerade Wand</strong> → 0 Ecken</li>' +
      '<li><strong>Wand mit einer Innenecke</strong> → 1 Ecke</li>' +
      '<li><strong>Zwei Richtungswechsel im feuchten Bereich</strong> → 2 Ecken</li>' +
      '<li><strong>Freistehende Wand im Raum</strong> (nur Stirnseite sichtbar) → 0 zusätzliche Ecken</li>' +
      '</ul>' +
      '<span class="ilf-info-tip"><strong>Praxistipp:</strong> Wenn Sie unsicher sind, zählen Sie im Zweifel eine Ecke mehr. Die Berechnung berücksichtigt den Wandquerschnitt und sorgt dafür, dass ausreichend Material eingeplant wird.</span>',
    thick: '<h4>So können Sie die Mauerstärke bestimmen:</h4>' +
      '<ul>' +
      '<li>Bei Fenstern oder Türen messen (Laibung)</li>' +
      '<li>Bei Kellerfenstern oft direkt sichtbar</li>' +
      '<li>Steckdosen oder Rohrdurchführungen geben einen guten Anhaltspunkt</li>' +
      '<li>In Deutschland liegt die Mauerstärke häufig bei 30–38 cm</li>' +
      '</ul>' +
      '<span class="ilf-info-tip"><strong>Tipp:</strong> Wenn Sie unsicher sind, lassen Sie 36 cm stehen – das ist der gängigste Wert und wird von uns sicher mitberechnet.</span>'
  };

  function fieldHTML(id, label, unit, placeholder, errMsg, value, inputMode) {
    var info = FIELD_INFO[id];
    var input = '<input class="ilf-input" id="ilf-' + id + '" type="text" inputmode="' + (inputMode || "decimal") + '"' + (inputMode === "numeric" ? ' pattern="[0-9]*"' : '') + ' autocomplete="off" placeholder="' + placeholder + '"' + (value != null ? ' value="' + value + '"' : '') + '>';
    return '<div class="ilf-field" data-f="' + id + '">' +
      '<div class="ilf-label-row">' +
      '<label class="ilf-label" for="ilf-' + id + '">' + label + (unit ? ' <small>(' + unit + ')</small>' : '') + '</label>' +
      (info ? '<button type="button" class="ilf-info-btn" data-ilf-info="' + id + '" aria-expanded="false" aria-controls="ilf-info-' + id + '" aria-label="Erklärung anzeigen: ' + label + '">i</button>' : '') +
      '</div>' +
      '<div class="ilf-stepper" data-ilf-stepper="' + id + '">' +
        '<button type="button" class="ilf-stepper-btn" data-ilf-step="-1" aria-label="' + label + ' verringern">−</button>' +
        input +
        '<button type="button" class="ilf-stepper-btn" data-ilf-step="1" aria-label="' + label + ' erhöhen">+</button>' +
      '</div>' +
      (info ? '<div class="ilf-info-box" id="ilf-info-' + id + '">' + info + '</div>' : '') +
      '<p class="ilf-err">' + errMsg + "</p>" +
      "</div>";
  }

  function buildPanel(cfg) {
    var side = cfg.mode === "side";
    var faMasonry = readFaMasonry();
    var opts = '<option value="">Bitte wählen …</option>';
    for (var i = 0; i < MASONRY_OPTIONS.length; i++) {
      var o = MASONRY_OPTIONS[i];
      opts += '<option value="' + o.v + '"' + (o.v === faMasonry ? " selected" : "") + ">" + o.l + "</option>";
    }
    var p = d.createElement("div");
    p.className = "ilf-panel";
    p.id = "ilf-panel";
    var n = side ? "4" : "3";
    var sperre = side ? "Flächensperre" : "Horizontalsperre";
    p.innerHTML =
      '<p class="ilf-title">Nur noch ' + n + " Angaben zu Ihrer Wand</p>" +
      '<p class="ilf-sub">Nur noch ' + n + ' Angaben für Bohrplan, Preis und die genaue Menge Flaschen für Ihre ' + sperre + '.</p>' +
      (side
        ? fieldHTML("len", "Länge der betroffenen Wandfläche", "in Metern", "z. B. 6", "Bitte geben Sie die Länge in Metern an (z. B. 6).") +
          fieldHTML("hgt", "Höhe der betroffenen Wandfläche", "in Metern", "z. B. 1,5", "Bitte geben Sie die Höhe in Metern an (z. B. 1,5).")
        : fieldHTML("len", "Länge der betroffenen Wand", "in Metern", "z. B. 12", "Bitte geben Sie die Wandlänge in Metern an (z. B. 12).")) +
      fieldHTML("corners", "Außenecken", "Anzahl – 0, wenn keine", "z. B. 0", "Bitte 0–20 eingeben.", "0", "numeric") +
      fieldHTML("thick", "Wandstärke", "in cm – im Zweifel 36", "z. B. 36", "Bitte 10–120 cm eingeben.", "36") +
      '<div class="ilf-field" data-f="masonry">' +
        '<label class="ilf-label" for="ilf-masonry">Mauerwerk</label>' +
        '<select class="ilf-select" id="ilf-masonry">' + opts + "</select>" +
        (faMasonry ? '<p class="ilf-hint">✓ Aus Ihrer Feuchte-Analyse übernommen – bitte kurz prüfen.</p>' : "") +
        '<p class="ilf-err">Bitte wählen Sie Ihr Mauerwerk aus.</p>' +
      "</div>" +
      '<div class="ilf-footer">' +
        '<p class="ilf-almost">Gleich geschafft – Ihr Ergebnis erscheint sofort.</p>' +
        '<button type="button" class="ilf-go" id="ilf-go">Sanierung kalkulieren <span aria-hidden="true">→</span></button>' +
        '<p class="ilf-foot">✓ Kostenlos · ✓ Keine Kontaktdaten nötig · ✓ Dauert etwa 30 Sekunden</p>' +
      "</div>";
    return p;
  }

  /* ── ISO-WIZ-Module nacheinander laden (jeweils selbst-guarded) ── */
  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = d.createElement("script");
      s.src = src; s.async = true;
      s.onload = function () { res(); };
      s.onerror = function () { rej(new Error("load failed: " + src)); };
      d.head.appendChild(s);
    });
  }
  function ensureIsoWiz(cfg) {
    if (w.IsoWiz && w.IsoWiz.Calculations && typeof w.IsoWiz.Calculations.calculateFinalAnalysis === "function") {
      return Promise.resolve();
    }
    return loadScript(cfg.assets.storage)
      .then(function () { return loadScript(cfg.assets.config); })
      .then(function () { return loadScript(cfg.assets.calculations); })
      .then(function () {
        if (!(w.IsoWiz && w.IsoWiz.Calculations && typeof w.IsoWiz.Calculations.calculateFinalAnalysis === "function")) {
          throw new Error("IsoWiz.Calculations fehlt nach Laden");
        }
      });
  }

  function readCartQty() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { if (!r || !r.ok) throw new Error("cart read failed"); return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var sum = 0;
        for (var i = 0; i < items.length; i++) {
          if (String(items[i].variant_id) === String(VARIANT_ID)) sum += Number(items[i].quantity) || 0;
        }
        return sum;
      });
  }

  /* v398 BUGFIX: /cart/update.js ändert nur Mengen von Artikeln, die SCHON im
     Warenkorb liegen — beim leeren Warenkorb (Normalfall nach dem FA-Tool) kam
     200 OK zurück, aber das Paket landete nie im Cart. Der Kalkulator-Loader
     sah dann qty=0 ≠ berechnete Flaschen, LÖSCHTE die Analyse (cart-empty-
     cleanup) und zeigte den Startscreen statt der Ergebnisseite.
     Jetzt: /cart/add.js wenn das Paket fehlt, /cart/update.js nur zum Ändern,
     danach Verifikation der tatsächlichen Menge gegen /cart.js. */
  function setCartQty(qty) {
    qty = Math.max(1, Math.round(qty));
    return readCartQty().then(function (cur) {
      if (cur === qty) return null;
      var req;
      if (cur > 0) {
        var updates = {};
        updates[String(VARIANT_ID)] = qty;
        req = fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates })
        });
      } else {
        req = fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: VARIANT_ID, quantity: qty })
        });
      }
      return req.then(function (r) { if (!r || !r.ok) throw new Error("cart write failed"); return r.json(); });
    }).then(function () {
      return readCartQty();
    }).then(function (after) {
      if (after !== qty) throw new Error("cart verify failed " + after + "/" + qty);
    });
  }

  function withTimeout(promise, ms) {
    return new Promise(function (res, rej) {
      var t = setTimeout(function () { rej(new Error("timeout")); }, ms);
      promise.then(function (v) { clearTimeout(t); res(v); },
                   function (e) { clearTimeout(t); rej(e); });
    });
  }

  function isFieldValid(panel, id, side) {
    var el = panel.querySelector("#ilf-" + id);
    if (!el) return false;
    var value = el.value == null ? "" : String(el.value).trim();
    if (id === "len") { var len = num(value); return len > 0 && len <= 500; }
    if (id === "hgt") { var hgt = num(value); return !!side && hgt > 0 && hgt <= 20; }
    if (id === "corners") {
      var corners = value === "" ? 0 : num(value);
      return corners >= 0 && corners <= 20 && corners === Math.floor(corners);
    }
    if (id === "thick") {
      var thick = value === "" ? 36 : num(value);
      return thick >= 10 && thick <= 120;
    }
    if (id === "masonry") return !!value;
    return false;
  }

  function submit(cfg, panel, fallbackHref) {
    var side = cfg.mode === "side";
    var get = function (id) { return panel.querySelector("#ilf-" + id); };
    var mark = function (id, bad) {
      var f = panel.querySelector('[data-f="' + id + '"]');
      if (!f) return;
      f.classList.toggle("ilf-invalid", !!bad);
      f.classList.toggle("ilf-valid", !bad && f.classList.contains("ilf-touched"));
    };

    var len = num(get("len").value);
    var hgt = side ? num(get("hgt") && get("hgt").value) : null;
    var corners = get("corners").value.trim() === "" ? 0 : num(get("corners").value);
    var thick = get("thick").value.trim() === "" ? 36 : num(get("thick").value);
    var masonry = get("masonry").value;

    var ok = true;
    if (!isFieldValid(panel, "len", side)) { mark("len", true); ok = false; } else mark("len", false);
    if (side) { if (!isFieldValid(panel, "hgt", side)) { mark("hgt", true); ok = false; } else mark("hgt", false); }
    if (!isFieldValid(panel, "corners", side)) { mark("corners", true); ok = false; } else mark("corners", false);
    if (!isFieldValid(panel, "thick", side)) { mark("thick", true); ok = false; } else mark("thick", false);
    if (!isFieldValid(panel, "masonry", side)) { mark("masonry", true); ok = false; } else mark("masonry", false);
    if (!ok) {
      /* v448: vorher stille Validierung — der Klick war im Funnel unsichtbar
         und sah wie Abbruch aus. Jetzt benennt das Event die roten Felder. */
      var badIds = [];
      var badFields = panel.querySelectorAll(".ilf-field.ilf-invalid");
      for (var bi = 0; bi < badFields.length; bi++) badIds.push(badFields[bi].getAttribute("data-f"));
      track("loesung_flow_invalid", { typ: cfg.typ, fields: badIds.join(",") });
      track("loesung_flow_invalid_" + (cfg.typ === "seitlich" ? "seitlich" : "aufsteigend"));
      return;
    }

    var state = {
      moistureType: side ? "side" : "bottom",
      masonryType: masonry,
      masonryLabel: MASONRY_LABELS[masonry] || masonry,
      cornerCount: String(corners),
      wallThickness: String(thick),
      variationFaktor: 1
    };
    if (side) { state.surfaceLength = String(len); state.surfaceHeight = String(hgt); }
    else { state.wallLength = String(len); }

    /* Der Footer wird beim ersten Oeffnen aus panel in das Overlay-Sheet
       verschoben. Deshalb darf der Submit-Button nicht mehr ausschliesslich
       innerhalb von panel gesucht werden. */
    var btn = panel.querySelector("#ilf-go") || d.getElementById("ilf-go");
    if (!btn) {
      track("loesung_flow_error", { typ: cfg.typ, saved: 0, msg: "submit button missing" });
      return;
    }
    btn.disabled = true;
    var btnOld = btn.innerHTML;
    btn.innerHTML = "Sanierung wird kalkuliert …";
    track("loesung_flow_submit", { typ: cfg.typ, len: len, corners: corners, thick: thick, masonry: masonry });
    /* B4: Zaehler nach Sperrtyp trennen — die Nenner (loesung_aufsteigend_loaded 911 vs.
       loesung_seitlich_loaded 145) waren getrennt, die Zaehler nicht. */
    track("loesung_flow_submit_" + (cfg.typ === "seitlich" ? "seitlich" : "aufsteigend"));

    var target = KALK_URL + "?source=loesung-flow&typ=" + encodeURIComponent(cfg.typ);

    /* v398: merken, ob die Analyse schon sicher berechnet + gespeichert ist —
       davon hängt ab, welcher Fehlerweg erlaubt ist (s. catch unten). */
    var analysisSaved = false;

    withTimeout(
      ensureIsoWiz(cfg).then(function () {
        /* Original-Berechnung — speichert analysis selbst (prefixed + isofinAnalysis + Sticky) */
        var analysis = w.IsoWiz.Calculations.calculateFinalAnalysis(state);
        if (!analysis || !(analysis.calculatedBottles > 0)) throw new Error("analysis leer");
        /* Wizard-State für Rück-Navigation konsistent halten */
        try { if (w.IsoWiz.Storage && w.IsoWiz.Storage.set) w.IsoWiz.Storage.set("state", state); } catch (e) {}
        /* Resume-Fallback-Keys (step-4 liest sie, falls Storage-API-Weg scheitert).
           v398: zusätzlich localStorage — überlebt auch einen neuen Tab. */
        try {
          var payload = JSON.stringify(analysis);
          w.sessionStorage.setItem("__ISOWIZ_RESUME_ANALYSIS__", payload);
          w.localStorage.setItem("__ISOWIZ_RESUME_ANALYSIS__", payload);
        } catch (e) {}
        try { w.sessionStorage.setItem("__ISOWIZ_START_INTENT__", JSON.stringify({ targetStep: "step-4", source: "loesung-flow" })); } catch (e) {}
        analysisSaved = true;
        /* Cart-Menge setzen (add/update + Verify) -> Loader-Resume-Bedingung
           (qty === calculatedBottles). v398: 1 automatischer Wiederholversuch. */
        return setCartQty(analysis.calculatedBottles).catch(function () {
          return new Promise(function (res) { setTimeout(res, 700); }).then(function () {
            return setCartQty(analysis.calculatedBottles);
          });
        });
      }),
      15000
    ).then(function () {
      w.location.href = target;
    }).catch(function (err) {
      track("loesung_flow_error", { typ: cfg.typ, saved: analysisSaved ? 1 : 0, msg: String(err && err.message || err).slice(0, 80) });
      var showRetry = function () {
        btn.disabled = false;
        btn.innerHTML = btnOld;
        var msg = btn.parentNode && btn.parentNode.querySelector(".ilf-neterr");
        if (!msg) {
          msg = d.createElement("div");
          msg.className = "ilf-neterr";
          msg.style.cssText = "color:#D6001C;font-size:13.5px;font-weight:600;margin-top:10px;text-align:center;";
          btn.parentNode.appendChild(msg);
        }
        msg.textContent = "Verbindung unterbrochen — bitte tippen Sie noch einmal auf \u00bbSanierung kalkulieren\u00ab.";
      };
      if (analysisSaved) {
        /* v398-SICHERHEITSNETZ: Berechnung ist fertig gespeichert, nur der
           Warenkorb ließ sich (nach 2 Versuchen) nicht setzen. NIEMALS zum
           Kalkulator-Start ausweichen — dessen Aufräum-Logik löscht bei
           leerem Warenkorb die Analyse. Stattdessen: liegt DOCH etwas im
           Warenkorb, weiter zur Ergebnisseite (dort greift die Resume-/
           Mismatch-Behandlung); sonst hier bleiben und erneut anbieten. */
        readCartQty().then(
          function (q) { if (q > 0) { w.location.href = target; } else { showRetry(); } },
          function () { showRetry(); }
        );
        return;
      }
      /* Berechnung selbst nicht möglich (Script-Ladefehler o. ä.):
         sanfter Fallback in den Kalkulator, dort kann neu gerechnet werden. */
      btn.disabled = false;
      btn.innerHTML = btnOld;
      w.location.href = fallbackHref || target;
    });
  }

  /* v445: GA4-Lead bei Ankunft ueber das Feuchtigkeitsanalyse-Tool (Attributions-Flag ?fa=1,
     gesetzt in dashboard-mod-analyse.js VOR dem Redirect hierher) -- feuert NICHT bei
     Direkt-/Ad-Traffic auf die Loesungsseite, da die dann kein ?fa=1 mitbringen. Laeuft auf
     der Ziel-Seite (nicht beim Absenden vor der Navigation), damit die Netzwerk-Anfrage nicht
     durch den Seitenwechsel abgebrochen werden kann. Feuert genau einmal, danach wird das
     Flag aus der URL entfernt (kein Doppel-Feuern bei Reload, saubere URL fuer den Nutzer). */
  function fireFaArrivalLead(typ) {
    try {
      var qp = new w.URLSearchParams(w.location.search);
      if (qp.get('fa') !== '1') return;
      if (w.isofinGA) {
        /* lead_type (v502): kennzeichnet die Herkunft, damit sich Endkunden-Leads aus der
           Feuchtigkeitsanalyse in GA4 von den Haendler-Anfragen trennen lassen. Ohne diesen
           Parameter landen beide unter demselben generate_lead und sind nicht auseinanderzuhalten. */
        w.isofinGA('generate_lead', { lead_type: 'feuchtigkeitsanalyse', content_name: 'Feuchtigkeitsanalyse: Loesungsseite erreicht', typ: typ || '' });
      }
      qp.delete('fa');
      var qs = qp.toString();
      w.history.replaceState(null, '', w.location.pathname + (qs ? '?' + qs : '') + w.location.hash);
    } catch (_eGa) {}
  }

  /* ═══ v447 Baustein A: Begründungs-Block („Darum dieses Ergebnis") ═══
     Funnel 6.7.–13.7.: Lösungsseite → Berechnen-CTA verliert 63 %. Der Hero
     BEHAUPTET das Analyse-Ergebnis, begründet es aber nicht mit den eigenen
     Angaben des Nutzers. Dieser Block spiegelt die 2–3 stärksten Antworten
     aus der Feuchte-Analyse als Echo + Deutung direkt unter dem Hero.
     Datenquelle: localStorage 'isofin_fa_result_v1' (schreibt dashboard-mod-
     analyse.js beim Redirect). ?fa=1 taugt NICHT als Träger: fireFaArrivalLead
     räumt es sofort aus der URL, der Block soll aber einen Reload überleben.
     Frische 15 min + Typ-Match → kein Block bei Direkt-/Ad-Traffic und nicht
     auf der falschen Lösungsseite. */
  var FA_RESULT_KEY = "isofin_fa_result_v1";
  var FA_RESULT_MAX_AGE = 15 * 60 * 1000;

  /* Deutungs-Map: NUR Antworten, die den Seiten-Typ laut SSOT-Gewichten
     (dashboard-fa-ssot-diagnose.js, WEIGHTS q1–q8) tatsächlich stützen.
     w = dortiges Gewicht → die 3 stärksten Treffer werden gezeigt.
     e = Echo der Angabe (fett), t = Deutung. Copy beschreibt Indizien,
     verspricht nichts (abmahnsicher), Sie-Form. */
  var FA_DEUTUNG = {
    kapillar: [
      { q: "q4", a: "mineral_crystal", w: 7, e: "Kristallartige Ablagerungen:", t: "sie entstehen, wenn aufsteigendes Wasser gelöste Salze aus dem Mauerwerk mitbringt und beim Verdunsten an der Oberfläche zurücklässt." },
      { q: "q4", a: "mineral_powder", w: 6, e: "Pulvrige, weiße Ablagerungen (Salzausblühungen):", t: "sie entstehen, wenn aufsteigendes Wasser gelöste Salze aus dem Mauerwerk an die Oberfläche trägt." },
      { q: "q3", a: "bottom_knee", w: 5, e: "Feuchtigkeit bis etwa Kniehöhe:", t: "genau die Steighöhe, die Wasser aus dem Boden in den feinen Poren des Mauerwerks typischerweise erreicht." },
      { q: "q5", a: "ground_floor", w: 4, e: "Betroffen ist das Erdgeschoss:", t: "dort hat das Mauerwerk direkten Kontakt zum feuchten Erdreich, aus dem Wasser aufsteigen kann." },
      { q: "q7", a: "pre_1930", w: 4, e: "Baujahr vor 1930:", t: "damals wurde oft ohne wirksame Horizontalsperre gebaut — oder die alte Sperre hat ihre Wirkung inzwischen verloren." },
      { q: "q3", a: "bottom_band", w: 3, e: "Unten am stärksten, nach oben weniger:", t: "typisch für Wasser, das aus dem Boden aufsteigt. Weiter oben darf das Bild auch fleckig oder punktuell werden — entscheidend ist, dass es unten am schlimmsten ist." },
      { q: "q3", a: "bottom_hip", w: 3, e: "Feuchtigkeit bis Hüfthöhe oder höher:", t: "bei saugfähigem Mauerwerk steigt Wasser aus dem Boden durchaus so hoch." },
      { q: "q5", a: "basement", w: 3, e: "Betroffen ist der Keller:", t: "dort steht das Mauerwerk direkt im feuchten Erdreich — der häufigste Ausgangspunkt für aufsteigende Feuchtigkeit." },
      { q: "q7", a: "between_1930_1970", w: 3, e: "Baujahr 1930–1970:", t: "die damals üblichen Sperrschichten (z. B. Bitumenpappe) sind heute häufig spröde und durchlässig geworden." },
      { q: "q6", a: "always", w: 3, e: "Dauerhaft feucht, unabhängig vom Wetter:", t: "Wasser aus dem Erdreich steht ständig nach — anders als Regen- oder Kondensfeuchte." },
      { q: "q2", a: "wont_dry", w: 3, e: "Die Stelle trocknet nicht ab:", t: "es kommt laufend Feuchtigkeit von unten nach — schneller, als sie verdunsten kann." },
      { q: "q2", a: "plaster_damage", w: 3, e: "Putz oder Anstrich platzt ab:", t: "aufsteigende Feuchtigkeit und die mitgeführten Salze sprengen mit der Zeit die Oberfläche ab." },
      { q: "q1", a: "active_no", w: 2, e: "Kein frei fließendes Wasser:", t: "ein Rohrbruch oder akut eindringendes Wasser ist damit unwahrscheinlich — das spricht für langsam nachziehende Feuchtigkeit." },
      { q: "q2", a: "dark_permanent", w: 2, e: "Dauerhaft dunkle Verfärbungen:", t: "die Wand ist durchfeuchtet und nicht nur oberflächlich beschlagen." },
      { q: "q8", a: "brick", w: 2, e: "Ziegel-Mauerwerk:", t: "es ist saugfähig und leitet Feuchtigkeit aus dem Boden besonders gut nach oben." },
      { q: "q8", a: "natural_stone", w: 2, e: "Naturstein- / Bruchstein-Mauerwerk:", t: "hier transportieren vor allem die Mörtelfugen die Feuchtigkeit nach oben." },
      { q: "q2", a: "cold_clammy", w: 1, e: "Die Wand fühlt sich kalt und klamm an:", t: "ein typisches Zeichen für durchfeuchtetes Mauerwerk." },
      { q: "q2", a: "smell_only", w: 1, e: "Muffiger Geruch:", t: "er deutet auf dauerhafte Feuchtigkeit im Mauerwerk hin." },
      { q: "q8", a: "hollow_block", w: 1, e: "Hohlblock- / Porenbeton-Mauerwerk:", t: "auch diese Steine nehmen Bodenfeuchte auf und leiten sie weiter." },
      { q: "q7", a: "between_1970_2000", w: 1, e: "Baujahr 1970–2000:", t: "auch in dieser Zeit wurden Sperrschichten teils beschädigt oder nicht durchgehend ausgeführt." }
    ],
    seitlich: [
      { q: "q6", a: "after_rain", w: 3, e: "Nach Regen wird es schlimmer:", t: "das spricht für Wasser, das von außen seitlich durch die Wand drückt." },
      { q: "q3", a: "middle_or_spot", w: 3, e: "Feuchtigkeit punktuell bzw. mitten in der Wand:", t: "so zeigt sich Wasser, das von außen seitlich eindringt — nicht von unten aufsteigt." },
      { q: "q3", a: "everywhere", w: 2, e: "Großflächig verteilte Feuchtigkeit:", t: "typisch, wenn Wasser über eine ganze erdberührte Wandfläche von außen eindringt." },
      { q: "q5", a: "basement", w: 2, e: "Betroffen ist der Keller:", t: "die Wand steht dort seitlich direkt am feuchten Erdreich." },
      { q: "q3", a: "bottom_hip", w: 2, e: "Feuchtigkeit bis Hüfthöhe oder höher:", t: "an erdberührten Wänden reicht das anliegende Erdreich oft genau so hoch." },
      { q: "q3", a: "bottom_band", w: 1, e: "Unten stärker ausgeprägt:", t: "auch seitlich eindringende Feuchtigkeit zeigt sich oft zuerst im unteren Wandbereich." }
    ]
  };

  function injectFaBegCSS() {
    if (d.getElementById("ilf-fabeg-css")) return;
    /* Gleiche Reset-fest-Technik wie .ilf-panel (Block liegt in .iso-fl):
       gedoppelte Klasse + !important auf allen visuellen Eigenschaften. */
    var css = [
      ".ilf-fabeg.ilf-fabeg{display:block !important;max-width:720px !important;margin:26px auto 0 !important;background:#fff !important;border:1.5px solid #e5e7eb !important;border-radius:16px !important;padding:22px 22px 16px !important;box-shadow:0 8px 28px rgba(0,0,0,.06) !important;font-family:'Rubik',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif !important;box-sizing:border-box !important;text-align:left !important}",
      ".ilf-fabeg .ilf-fabeg-kicker{display:inline-block !important;font-size:12.5px !important;font-weight:700 !important;letter-spacing:.06em !important;text-transform:uppercase !important;color:#B8001A !important;background:#fdf2f3 !important;border-radius:999px !important;padding:5px 12px !important;margin:0 0 10px !important;line-height:1.3 !important}",
      ".ilf-fabeg .ilf-fabeg-title{display:block !important;font-size:19px !important;font-weight:700 !important;color:#0f172a !important;margin:0 0 14px !important;line-height:1.35 !important}",
      ".ilf-fabeg .ilf-fabeg-list{display:block !important;margin:0 !important;padding:0 !important;list-style:none !important}",
      ".ilf-fabeg .ilf-fabeg-item{display:flex !important;align-items:flex-start !important;gap:10px !important;margin:0 0 11px !important;padding:0 !important}",
      ".ilf-fabeg .ilf-fabeg-check{flex:0 0 22px !important;width:22px !important;height:22px !important;border-radius:50% !important;background:#e7f6ee !important;color:#15803d !important;font-size:13px !important;font-weight:700 !important;display:inline-flex !important;align-items:center !important;justify-content:center !important;margin-top:1px !important}",
      ".ilf-fabeg .ilf-fabeg-text{display:block !important;font-size:15px !important;line-height:1.55 !important;color:#374151 !important}",
      ".ilf-fabeg .ilf-fabeg-text strong{font-weight:600 !important;color:#0f172a !important}",
      ".ilf-fabeg .ilf-fabeg-note{display:block !important;font-size:13px !important;color:#6b7280 !important;margin:12px 0 0 !important;padding:10px 0 0 !important;border-top:1px solid #f1f5f9 !important;line-height:1.5 !important}",
      "@media (max-width:760px){.ilf-fabeg.ilf-fabeg{max-width:none !important;margin:20px 14px 0 !important;padding:18px 16px 14px !important}.ilf-fabeg .ilf-fabeg-title{font-size:17px !important}.ilf-fabeg .ilf-fabeg-text{font-size:14px !important}}"
    ].join("");
    var st = d.createElement("style");
    st.id = "ilf-fabeg-css";
    st.textContent = css;
    d.head.appendChild(st);
  }

  function renderFaBegruendung(cfg) {
    var typ = cfg && cfg.typ;
    var map = FA_DEUTUNG[typ];
    if (!map) return;
    var data = null;
    try { data = JSON.parse(w.localStorage.getItem(FA_RESULT_KEY)); } catch (e) { return; }
    if (!data || !data.ts || (Date.now() - data.ts) > FA_RESULT_MAX_AGE) return;
    var resType = String(data.type || "");
    var match = typ === "kapillar" ? (resType === "kapillar" || resType === "kapillar_plus") : resType === typ;
    if (!match) return;

    var answers = data.answers || {};
    var hits = [];
    for (var i = 0; i < map.length; i++) {
      if (answers[map[i].q] === map[i].a) hits.push(map[i]);
    }
    if (!hits.length) return;
    hits.sort(function (a, b) { return b.w - a.w; });
    hits = hits.slice(0, 3);

    var anchor = d.querySelector(".fl-hero");
    var firstSection = d.querySelector(".fl-section");
    if (!anchor && !firstSection) return;

    var typLabel = typ === "kapillar" ? "aufsteigende Feuchtigkeit" : "seitlich eindringende Feuchtigkeit";
    var conf = String(data.confidence || "");
    var title = conf === "high"
      ? "Ihre Angaben sprechen überwiegend für " + typLabel
      : "Ihre Angaben könnten für " + typLabel + " sprechen";

    var items = "";
    for (var j = 0; j < hits.length; j++) {
      items += '<li class="ilf-fabeg-item"><span class="ilf-fabeg-check" aria-hidden="true">✓</span><span class="ilf-fabeg-text"><strong>' + hits[j].e + "</strong> " + hits[j].t + "</span></li>";
    }

    injectFaBegCSS();
    var box = d.createElement("div");
    box.className = "ilf-fabeg";
    box.innerHTML =
      '<span class="ilf-fabeg-kicker">Darum dieses Ergebnis</span>' +
      '<p class="ilf-fabeg-title">' + title + "</p>" +
      '<ul class="ilf-fabeg-list">' + items + "</ul>" +
      '<p class="ilf-fabeg-note">Diese Einschätzung beruht auf Ihren Angaben aus der Feuchte-Analyse. Sie ersetzt keine Begutachtung vor Ort.</p>';
    if (anchor) anchor.insertAdjacentElement("afterend", box);
    else firstSection.parentNode.insertBefore(box, firstSection);

    meas.fa = 1;
    track("loesung_fa_begruendung_view", { typ: typ, confidence: conf });
  }

  /* ═══ v448 Baustein 0 — Messbasis (UMSETZUNGSPLAN-LOESUNGSSEITE-CTA, 0.2) ═══
     Beantwortet die 63-%-Frage: sehen die Nicht-Klicker den CTA nicht
     (Sichtbarkeit), oder sehen sie ihn und klicken bewusst nicht (Überzeugung)?
     Bewusst schlank: max. 6 section_view + 1 exit pro Besuch, einmalig je
     Sektion, KEINE Scroll-Prozent-Pings. fa=1 markiert qualifizierte
     FA-Ankünfte (Baustein-A-Block wurde gerendert) als Board-Nenner. */
  var MEAS_SECS = ["hero", "fabeg", "cta_top", "cta_mid", "cta_end", "hendrik"];
  var meas = { fa: 0, t0: 0, maxSec: -1, exitSent: false, flowOpened: false };

  function initMeasurement(cfg) {
    var typ = (cfg && cfg.typ) || "";
    meas.t0 = Date.now();

    var els = {
      hero: d.querySelector(".fl-hero"),
      fabeg: d.querySelector(".ilf-fabeg"),
      hendrik: d.querySelector("#hendrik-contact-root")
    };
    var ctas = d.querySelectorAll("[data-iso-flow-open]");
    if (ctas[0]) els.cta_top = ctas[0];
    if (ctas[1]) els.cta_mid = ctas[1];
    if (ctas[2]) els.cta_end = ctas[2];

    if (w.IntersectionObserver) {
      var io = new w.IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i];
          if (!en.isIntersecting) continue;
          /* "gesehen" = 50 % des Elements ODER (bei Blöcken höher als der halbe
             Viewport, z. B. Hendrik mobil) 50 % der Viewport-Höhe gefüllt —
             sonst feuert ein hoher Block auf kleinen Screens nie. */
          var vh = w.innerHeight || 800;
          var visible = en.intersectionRatio >= 0.5 ||
            (en.intersectionRect && en.intersectionRect.height >= vh * 0.5);
          if (!visible) continue;
          var sec = en.target.getAttribute("data-ilf-sec");
          io.unobserve(en.target);
          var idx = MEAS_SECS.indexOf(sec);
          if (idx > meas.maxSec) meas.maxSec = idx;
          track("loesung_section_view", { typ: typ, sec: sec, fa: meas.fa });
          /* B4 (Auftrag 2026-09): Welche Sektion wurde ueberhaupt gesehen? Ohne Namen
             war nur die Gesamtzahl bekannt (1.007), nicht die Abbruchstelle. */
          track("loesung_seen_" + String(sec).toLowerCase().replace(/[^a-z0-9]+/g, "_"));
        }
      }, { threshold: [0, 0.5] });
      for (var k in els) {
        if (els.hasOwnProperty(k) && els[k]) {
          els[k].setAttribute("data-ilf-sec", k);
          io.observe(els[k]);
        }
      }
    }

    var sendExit = function () {
      if (meas.exitSent) return;
      meas.exitSent = true;
      track("loesung_exit", {
        typ: typ,
        fa: meas.fa,
        dwell_s: Math.round((Date.now() - meas.t0) / 1000),
        max_sec: meas.maxSec >= 0 ? MEAS_SECS[meas.maxSec] : "none",
        panel: meas.flowOpened ? 1 : 0
      });
      /* B4 (Auftrag 2026-09): Wie weit kam der Besucher, und hatte er das Panel offen?
         Beides stand nur im Payload — damit war die Abbruchstelle nicht auswertbar. */
      track("loesung_exit_max_" + String(meas.maxSec >= 0 ? MEAS_SECS[meas.maxSec] : "none")
        .toLowerCase().replace(/[^a-z0-9]+/g, "_"));
      track("loesung_exit_panel_" + (meas.flowOpened ? "ja" : "nein"));
    };
    w.addEventListener("pagehide", sendExit);
    d.addEventListener("visibilitychange", function () {
      if (d.visibilityState === "hidden") sendExit();
    });
  }

  function init(cfg) {
    fireFaArrivalLead(cfg && cfg.typ);
    try { renderFaBegruendung(cfg); } catch (eFaBeg) {}
    try { initMeasurement(cfg); } catch (eMeas) {}
    /* v449: verwaisten History-Eintrag neutralisieren — falls der Nutzer nach
       Submit→Kalkulator→Zurück auf dieser Seite landet, während aus einem
       früheren Besuch noch ein {ilfOverlay:1}-State ansteht (siehe
       OVERLAY-SPEZIFIKATION.md, Pflicht-Mitigation "History-Leak"). */
    try { if (w.history.state && w.history.state.ilfOverlay) w.history.replaceState(null, ""); } catch (eHist) {}
    if (!cfg || !cfg.assets) return;
    injectCSS();
    var openers = d.querySelectorAll("[data-iso-flow-open]");
    if (!openers.length) return;

    var panel = buildPanel(cfg);
    var opened = false;

    /* ═══ v449: Eingabe-Overlay statt Scroll-Sprung (Björn 13.07. abends) ═══
       Panel-DOM zieht listener-erhaltend per appendChild in den Overlay-
       Container um (lazy beim ersten Klick) — buildPanel/submit()/Cart/
       Redirect bleiben zu 100 % unangetastet. Ein zentrales Zustandsobjekt
       (isOpen/isClosing/statePushed) ist die einzige Wahrheitsquelle gegen
       Doppel-Tap und History-Races (Skeptiker-Härtetest, Pflicht-Mitigation). */
    var ovBuilt = false, ovOpen = false, ovClosing = false, statePushed = false;
    var ovRoot = null, scrollRegion = null;
    var savedScrollY = 0, savedSnapshot = "", opener = null, vvUpdateFn = null, ccbTimer = null;

    function fieldSnapshot() {
      var ids = ["len", "hgt", "corners", "thick", "masonry"];
      var parts = [];
      for (var i = 0; i < ids.length; i++) {
        var el = panel.querySelector("#ilf-" + ids[i]);
        parts.push(el ? el.value : "");
      }
      return parts.join("|");
    }
    function lockScroll() {
      d.documentElement.style.overflow = "hidden";
      d.body.style.overflow = "hidden";
    }
    function unlockScroll() {
      d.documentElement.style.overflow = "";
      d.body.style.overflow = "";
    }
    /* v478-Fix (16.07.): Der Consent-Banner (Pandectes, z-index 2147483647) liegt
       zwangsläufig über dem Overlay (100200) und begrub mobil den "Ergebnis
       anzeigen"-Button zu 100 % — der Tap landete auf "Annehmen" (0 Submits ab
       14.07.). Seit dem Bottom-Sheet-Umbau (v449) klebt der Footer am unteren
       Rand, genau in der Banner-Zone; davor lag das Panel inline in der Seite.
       Den Banner fassen wir NICHT an (Consent) — wir halten unser Sheet frei.
       Gezählt wird nur, was unten verankert ist UND uns horizontal überlappt:
       ein Desktop-Banner unten links lässt das zentrierte Sheet so unberührt. */
    function consentBottomOverlap() {
      try {
        var sheet = ovRoot && ovRoot.querySelector(".ilf-ov-sheet");
        if (!sheet) return 0;
        var sr = sheet.getBoundingClientRect();
        if (!(sr.width > 0)) return 0;
        var vv = w.visualViewport;
        var viewportTop = vv ? vv.offsetTop : 0;
        var vh = (vv && vv.height) || w.innerHeight;
        var viewportBottom = viewportTop + vh;
        var nodes = d.querySelectorAll("#pandectes-banner .cc-window, .cc-window, #shopify-pc__banner");
        var worst = 0;
        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          if (ovRoot.contains(el)) continue;
          var cs = w.getComputedStyle(el);
          if (cs.position !== "fixed" && cs.position !== "sticky") continue;
          if (cs.display === "none" || cs.visibility === "hidden" || parseFloat(cs.opacity) === 0) continue;
          var r = el.getBoundingClientRect();
          if (!(r.height > 0 && r.width > 0)) continue;
          /* Pandectes nutzt je nach Breakpoint 0 oder 16 px Abstand zum Rand.
             48 px Toleranz decken diesen Rand ab, ohne mittige Dialoge irrtuemlich
             als Bottom-Banner zu behandeln. */
          if (r.bottom < viewportBottom - 48) continue;            /* nicht unten verankert */
          if (r.top >= viewportBottom || r.bottom <= viewportTop) continue;
          if (r.right <= sr.left || r.left >= sr.right) continue; /* kein horizontaler Überlapp */
          worst = Math.max(worst, viewportBottom - Math.max(r.top, viewportTop));
        }
        /* Kein 50-%-Deckel: Bereits wenige verdeckte Pixel machen den CTA
           unanklickbar, weil der Consent-Banner den hoechsten z-index besitzt. */
        return Math.max(0, Math.round(Math.min(worst, vh)));
      } catch (eCc) { return 0; }
    }
    function updateCcb() {
      if (!ovRoot) return;
      try {
        var overlap = consentBottomOverlap();
        var footer = ovRoot.querySelector(".ilf-footer");
        ovRoot.style.setProperty("--ilf-ccb", overlap + "px");
        if (footer) ovRoot.style.setProperty("--ilf-footer-h", Math.ceil(footer.getBoundingClientRect().height) + "px");
        ovRoot.classList.toggle("ilf-ov-has-ccb", overlap > 0);
      } catch (eSet) {}
    }
    function attachConsentTracking() {
      if (!ovRoot) return;
      updateCcb();
      w.addEventListener("resize", updateCcb);
      /* Der Banner verschwindet, sobald zugestimmt wird — dann muss das Sheet die
         Höhe sofort zurückbekommen. Günstiges Nachmessen statt MutationObserver. */
      ccbTimer = w.setInterval(updateCcb, 400);
    }
    function detachConsentTracking() {
      try { w.removeEventListener("resize", updateCcb); } catch (eR) {}
      if (ccbTimer) { w.clearInterval(ccbTimer); ccbTimer = null; }
    }
    function attachViewportTracking() {
      if (!w.visualViewport || !ovRoot) return;
      var vv = w.visualViewport;
      vvUpdateFn = function () {
        try {
          ovRoot.style.setProperty("--ilf-vvh", vv.height + "px");
          ovRoot.style.setProperty("--ilf-vvt", vv.offsetTop + "px");
          updateCcb();   /* Tastatur/Adressleiste ändern die Banner-Lage mit */
        } catch (eVv) {}
      };
      vvUpdateFn();
      vv.addEventListener("resize", vvUpdateFn);
      vv.addEventListener("scroll", vvUpdateFn);
    }
    function detachViewportTracking() {
      if (w.visualViewport && vvUpdateFn) {
        try { w.visualViewport.removeEventListener("resize", vvUpdateFn); w.visualViewport.removeEventListener("scroll", vvUpdateFn); } catch (eVv2) {}
      }
      vvUpdateFn = null;
    }
    function trapTab(e) {
      var focusables = ovRoot.querySelectorAll("button, input, select, [tabindex]");
      var visible = [];
      for (var i = 0; i < focusables.length; i++) {
        if (focusables[i].offsetParent !== null) visible.push(focusables[i]);
      }
      if (!visible.length) return;
      var firstEl = visible[0], lastEl = visible[visible.length - 1];
      if (e.shiftKey) {
        if (d.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      } else {
        if (d.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      }
    }
    function isSubmitting() {
      var btn = (ovRoot && ovRoot.querySelector("#ilf-go")) || panel.querySelector("#ilf-go");
      return !!(btn && btn.disabled);
    }

    function ensureOverlay() {
      if (ovBuilt) return;
      var ov = d.createElement("div");
      ov.className = "ilf-ov";
      ov.id = "ilf-ov";
      ov.setAttribute("role", "dialog");
      ov.setAttribute("aria-modal", "true");
      ov.setAttribute("aria-labelledby", "ilf-ov-title");
      /* v449-Revision (Björn 13./14.07.): "Kostenlos" muss hervorstechen
         (Kicker-Pille) + der Titel sagt WAS jetzt passiert; die Feld-Anzahl
         nennt der Sub-Satz im Panel ("Nur noch X Angaben für ..."). */
      ov.innerHTML =
        '<div class="ilf-ov-backdrop"></div>' +
        '<div class="ilf-ov-sheet">' +
          '<div class="ilf-ov-head">' +
            '<div class="ilf-ov-head-text">' +
              '<span class="ilf-ov-kicker">Kostenlose Berechnung</span>' +
              '<span class="ilf-ov-title" id="ilf-ov-title">Ihre Sanierung berechnen</span>' +
            "</div>" +
            '<button type="button" class="ilf-ov-x" aria-label="Eingabe-Fenster schließen">✕ Schließen</button>' +
          "</div>" +
          '<div class="ilf-ov-scroll"></div>' +
        "</div>";
      d.body.appendChild(ov);

      scrollRegion = ov.querySelector(".ilf-ov-scroll");
      scrollRegion.appendChild(panel);
      panel.classList.add("ilf-open");
      /* v449-Fix: .ilf-footer als ECHTE dritte Sheet-Zone (flex:none) statt
         position:sticky INNERHALB des scrollenden Panels — bei viel Content
         (z. B. seitlich mit 4 Feldern) auf niedrigeren Viewports überlappte
         der sticky-Footer sonst das letzte Feld (Mauerwerk), weil sein
         Fluss-Ende mit dem Content-Ende zusammenfiel. Gleicher DOM-Knoten,
         nur an eine andere Stelle im Sheet gehängt — Listener bleiben. */
      var footerEl = panel.querySelector(".ilf-footer");
      if (footerEl) ov.querySelector(".ilf-ov-sheet").appendChild(footerEl);

      ov.querySelector(".ilf-ov-x").addEventListener("click", function () { requestClose("x"); });

      var backdrop = ov.querySelector(".ilf-ov-backdrop");
      var backdropDown = false;
      backdrop.addEventListener("mousedown", function (e) { backdropDown = (e.target === backdrop); });
      backdrop.addEventListener("mouseup", function (e) {
        var pointerFine = w.matchMedia && w.matchMedia("(hover:hover) and (pointer:fine)").matches;
        if (backdropDown && e.target === backdrop && pointerFine) requestClose("backdrop");
        backdropDown = false;
      });

      ov.addEventListener("keydown", function (e) {
        if (e.key === "Tab") trapTab(e);
      });

      scrollRegion.addEventListener("focusin", function (e) {
        var t = e.target;
        if (!t || !t.classList || !(t.classList.contains("ilf-input") || t.classList.contains("ilf-select"))) return;
        setTimeout(function () {
          try { t.scrollIntoView({ block: "center", behavior: "auto" }); } catch (eSi) {}
        }, 250);
      });

      ovRoot = ov;
      ovBuilt = true;
    }

    function openOverlay(openerEl) {
      if (ovOpen || ovClosing) return; /* Open-/Doppeltap-Guard — VOR pushState/Snapshot/Tracking */
      ensureOverlay();
      ovOpen = true;
      opener = openerEl;
      savedScrollY = w.scrollY || w.pageYOffset || 0;
      savedSnapshot = fieldSnapshot();
      ovRoot.classList.add("ilf-ov-open");
      try { w.history.pushState({ ilfOverlay: 1 }, ""); statePushed = true; } catch (eHist2) { statePushed = false; }
      lockScroll();
      /* v372: Fokus MUSS synchron im Klick bleiben (sonst öffnet iOS die
         Tastatur nicht) — kein setTimeout/rAF davor. */
      var first = panel.querySelector(".ilf-input");
      if (first) {
        try { first.focus({ preventScroll: true }); } catch (eF) { try { first.focus(); } catch (eF2) {} }
      }
      meas.flowOpened = true;
      if (!opened) {
        opened = true;
        track("loesung_flow_open", { typ: cfg.typ, ui: "overlay" });
        track("loesung_flow_open_" + (cfg.typ === "seitlich" ? "seitlich" : "aufsteigend"));
      }
      attachViewportTracking();
      attachConsentTracking();
    }

    function requestClose(reason) {
      if (!ovOpen || ovClosing) return;
      if (isSubmitting()) return; /* Submit-Phase absichern: Schließwege gesperrt */
      ovClosing = true;
      if (statePushed) {
        try { w.history.back(); } catch (eBack) { finalizeClose(); }
      } else {
        finalizeClose();
      }
    }

    function finalizeClose() {
      if (!ovOpen && !ovClosing) return; /* idempotent */
      var wasOpen = ovOpen;
      var filled = fieldSnapshot() !== savedSnapshot ? 1 : 0;
      ovOpen = false;
      ovClosing = false;
      statePushed = false;
      if (ovRoot) ovRoot.classList.remove("ilf-ov-open");
      unlockScroll();
      detachViewportTracking();
      detachConsentTracking();
      try { w.scrollTo(0, savedScrollY); } catch (eScroll) {}
      try { if (opener) opener.focus(); } catch (eFoc) {}
      if (wasOpen) {
        track("loesung_flow_close", { typ: cfg.typ, filled: filled });
        track("loesung_flow_close_" + (cfg.typ === "seitlich" ? "seitlich" : "aufsteigend"));
      }
    }

    w.addEventListener("popstate", function (e) {
      if (ovOpen && isSubmitting()) {
        /* Zurück während "Sanierung wird kalkuliert …": State sofort
           re-pushen, Overlay bleibt offen (Pflicht-Mitigation Submit-Phase). */
        try { w.history.pushState({ ilfOverlay: 1 }, ""); } catch (eRe) {}
        return;
      }
      if (ovOpen || ovClosing) {
        finalizeClose();
        return;
      }
      if (e.state && e.state.ilfOverlay) {
        /* Vorwärts-Navigation auf einen verwaisten Overlay-State (Overlay
           schon zu / nie geöffnet in diesem Ladezyklus) -> überspringen. */
        try { w.history.back(); } catch (eSkip) {}
      }
    });

    d.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && ovOpen) requestClose("esc");
    });

    function scrollToInvalid() {
      var bad = panel.querySelector(".ilf-field.ilf-invalid");
      if (!bad) return;
      var reduced = w.matchMedia && w.matchMedia("(prefers-reduced-motion: reduce)").matches;
      try { bad.scrollIntoView({ block: "center", behavior: reduced ? "auto" : "smooth" }); } catch (eSc) {}
      var f = bad.querySelector(".ilf-input,.ilf-select");
      if (f) { try { f.focus(); } catch (eF3) {} }
    }

    for (var i = 0; i < openers.length; i++) (function (a) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        openOverlay(a);
      });
    })(openers[i]);

    /* ⓘ-Aufklapper: ein Panel offen, Öffnen wird getrackt */
    panel.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest ? e.target.closest("[data-ilf-info]") : null;
      if (!btn) return;
      var id = btn.getAttribute("data-ilf-info");
      var box = panel.querySelector("#ilf-info-" + id);
      if (!box) return;
      var offen = box.classList.contains("ilf-open");
      var boxes = panel.querySelectorAll(".ilf-info-box.ilf-open");
      for (var i2 = 0; i2 < boxes.length; i2++) boxes[i2].classList.remove("ilf-open");
      var btns = panel.querySelectorAll(".ilf-info-btn.ilf-on");
      for (var j2 = 0; j2 < btns.length; j2++) { btns[j2].classList.remove("ilf-on"); btns[j2].setAttribute("aria-expanded", "false"); }
      if (!offen) {
        box.classList.add("ilf-open");
        btn.classList.add("ilf-on");
        btn.setAttribute("aria-expanded", "true");
        track("loesung_flow_info_open", { field: id, typ: cfg.typ });
      }
    });

    /* v480: Feldstatus sofort verstaendlich machen. Rot erscheint erst nach
       einer abgeschlossenen ungueltigen Eingabe; gueltige Werte werden gruen
       bestaetigt. Beim Tippen bleibt ein noch unvollstaendiger Wert neutral. */
    function updateFieldFeedback(control, showInvalid, userChanged) {
      if (!control) return;
      var field = control.closest ? control.closest(".ilf-field") : null;
      if (!field) return;
      if (userChanged) field.classList.add("ilf-touched");
      var id = field.getAttribute("data-f");
      var requiredEmpty = (id === "len" || id === "hgt" || id === "masonry") && !String(control.value || "").trim();
      var valid = !requiredEmpty && isFieldValid(panel, id, cfg.mode === "side");
      var touched = field.classList.contains("ilf-touched");
      field.classList.toggle("ilf-valid", valid && touched);
      field.classList.toggle("ilf-invalid", !!showInvalid && !valid && touched);
    }
    var feedbackControls = panel.querySelectorAll(".ilf-input,.ilf-select");
    for (var fc = 0; fc < feedbackControls.length; fc++) (function (control) {
      control.addEventListener("pointerdown", function () {
        var field = control.closest ? control.closest(".ilf-field") : null;
        if (field) field.classList.add("ilf-user-focused");
      });
      control.addEventListener("input", function () { updateFieldFeedback(control, false, true); });
      control.addEventListener("change", function () { updateFieldFeedback(control, true, true); });
      /* Verlassen bestaetigt auch einen unveraenderten Standardwert: Der Nutzer
         hat ihn sichtbar geprueft. Vor dem ersten Fokus bleibt er neutral. */
      control.addEventListener("blur", function () {
        var field = control.closest ? control.closest(".ilf-field") : null;
        var userFocused = !!(field && field.classList.contains("ilf-user-focused"));
        updateFieldFeedback(control, true, userFocused);
        if (field) field.classList.remove("ilf-user-focused");
      });
      /* Mauerwerk stammt ggf. bereits aus der vorherigen Feuchte-Analyse und
         ist damit eine echte Nutzereingabe, kein lokaler Standardwert. */
      if (control.id === "ilf-masonry" && String(control.value || "").trim()) updateFieldFeedback(control, false, true);
    })(feedbackControls[fc]);

    var stepperSettings = {
      len: { step: 0.5, min: 0.5, max: 500, decimals: 1, empty: 0 },
      hgt: { step: 0.1, min: 0.1, max: 20, decimals: 1, empty: 0 },
      corners: { step: 1, min: 0, max: 20, decimals: 0, empty: 0 },
      thick: { step: 1, min: 10, max: 120, decimals: 0, empty: 36 }
    };
    function applyStepper(id, direction) {
      var settings = stepperSettings[id];
      var control = panel.querySelector("#ilf-" + id);
      if (!settings || !control) return;
      var current = num(control.value);
      if (!isFinite(current)) current = settings.empty;
      var factor = Math.pow(10, settings.decimals);
      var next = Math.round((current + direction * settings.step) * factor) / factor;
      next = Math.max(settings.min, Math.min(settings.max, next));
      var formatted = settings.decimals ? next.toFixed(settings.decimals).replace(/\.0+$/, "").replace(".", ",") : String(Math.round(next));
      control.value = formatted;
      control.dispatchEvent(new Event("input", { bubbles: true }));
      control.dispatchEvent(new Event("change", { bubbles: true }));
    }
    panel.addEventListener("click", function (e) {
      var stepButton = e.target && e.target.closest ? e.target.closest("[data-ilf-step]") : null;
      if (!stepButton) return;
      e.preventDefault();
      var stepper = stepButton.closest("[data-ilf-stepper]");
      if (!stepper) return;
      applyStepper(stepper.getAttribute("data-ilf-stepper"), Number(stepButton.getAttribute("data-ilf-step")) || 0);
    });
    panel.addEventListener("keydown", function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains("ilf-input")) return;
      if (e.key !== "ArrowUp" && e.key !== "ArrowDown") return;
      var field = e.target.closest(".ilf-field");
      var id = field && field.getAttribute("data-f");
      if (!stepperSettings[id]) return;
      e.preventDefault();
      applyStepper(id, e.key === "ArrowUp" ? 1 : -1);
    });

    panel.querySelector("#ilf-go").addEventListener("click", function () {
      submit(cfg, panel, openers[0].getAttribute("href"));
      scrollToInvalid();
    });
    panel.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.target && e.target.classList.contains("ilf-input")) {
        e.preventDefault();
        submit(cfg, panel, openers[0].getAttribute("href"));
        scrollToInvalid();
      }
    });
  }

  /* Sichtbarer Deployment-Dump fuer Live-Diagnosen:
     IsoLoesungFlow.VERSION oder __ISO_LOESUNG_FLOW_VERSION__. */
  w.__ISO_LOESUNG_FLOW_VERSION__ = VERSION;
  w.IsoLoesungFlow = { init: init, VERSION: VERSION };
})(window, document);
